import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WithRender from '@/Pages/Admin/Modules/ManagePackage/tab/Reviews/reviews.html';
import {common} from '@/Pages/Admin/Modules/Common/Services/Common';
import {trekService} from '@/Pages/Admin/Modules/ManagePackage/Services/Trekservice';
import Pager from '@/Pages/Admin/Modules/Common/Controllers/Pager';
import {TrekReviewModel} from '@/Pages/Admin/Modules/Models/ManagePackage/Tab/Reviews/TrekReviewModel';

@WithRender
@Component({
    components: {
        Pager,
    },
})

export default class Reviews extends Vue {
    protected ui: any = {};
    protected item: any = {};

    constructor() {
        super();
        this.ui = {
            status: {
                isLoading: {
                    getReviewList: false,
                },
            },
            error: {
                errors: {},
                has_error: false,
                error_message: {},
            },
            paging: {
                current_page: 1,
                last_page: 1,
                per_page: 0,
            },
        };

        this.item = {
            reviewsList: new TrekReviewModel({}),
            selectedReview: new TrekReviewModel({}),
        };

    }

    public created() {
        this.getAllReviewList();
    }

    public async getAllReviewList() {
        this.ui.status.isLoading.getReviewList = true;
        let data = {
            trek_id: this.$route.query.id,
            current_page: this.ui.paging.current_page,
        };
        trekService
            .getReviewList(data)
            .then((res: any) => {
                res.data.data.data.filter((review: any, index: any) => {
                    let str = review.description;
                    let resultString =
                        str
                            .split(' ')
                            .slice(0, 5)
                            .join(' ') + '...';
                    review.short_review = resultString;
                });
                this.item.reviewsList = res.data.data.data ? res.data.data.data : [];
                this.ui.status.isLoading.getReviewList = false;
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.isLoading.getReviewList = false;
            });
    }

    public onViewReviewClick(review: any) {
        this.hideReviewModal();
        this.item.selectedReview = review;
    }

    public hideReviewModal() {
        $('#review-modal').modal('hide');
        $('.modal-backdrop').remove();
        this.item.selectedReview = new TrekReviewModel({});
    }

    public onPaging(CurrentPage: number) {
        this.ui.paging.current_page = CurrentPage;
        this.getAllReviewList();
    }
}
